import React from "react";

const items = [
  "Mantenimiento Preventivo",
  "Reparación Especializada",
  "Venta de Transformadores",
  "Pruebas Eléctricas",
  "Diagnóstico Avanzado",
  "Servicio de Emergencia 24/7",
  "Tipo Aceite",
  "Hasta 3000 kVA",
  "RETIE Certificado",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[#0a0a0a] border-y border-white/5 py-6 overflow-hidden"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {[...items, ...items].map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-8 text-sm uppercase tracking-[0.25em] text-[#a0aabf]"
          >
            <span className="w-1.5 h-1.5 bg-[#ff6b00]" />
            <span>{it}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
